import { Injectable } from '@angular/core';
import { AuthResult, UserLoginDto } from '../utils/auth.utils';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthHttpService {
  baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  loginUser(authData: UserLoginDto): Observable<AuthResult> {
    return this.http.post<AuthResult>(`${this.baseUrl}login`, JSON.stringify(authData));
  }

  loginByNonce(id: string): Observable<AuthResult> {
    return this.http.post<AuthResult>(
      `${this.baseUrl}staffportal/login/nonce`,
      JSON.stringify({ nonceId: id })
    );
  }
}
